module.exports = "<p>Logout</p>"